import { render, staticRenderFns } from "./AddEditRedeSocial.vue?vue&type=template&id=227607e1"
import script from "./AddEditRedeSocial.vue?vue&type=script&lang=js"
export * from "./AddEditRedeSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports